// 移动端筛选白屏问题终极修复方案
(function() {
  'use strict';
  
  // 防止重复初始化
  if (window.mobileFiltersV3Initialized) return;
  window.mobileFiltersV3Initialized = true;
  
  console.log('初始化移动端筛选修复V3...');
  
  // 等待所有依赖加载完成
  function waitForDependencies() {
    return new Promise((resolve) => {
      const checkDependencies = () => {
        if (typeof FacetFiltersForm !== 'undefined' && document.querySelector('.facets__button')) {
          resolve();
        } else {
          setTimeout(checkDependencies, 100);
        }
      };
      checkDependencies();
    });
  }
  
  // 移动端筛选管理器
  const MobileFilterManager = {
    isOpen: false,
    scrollPosition: 0,
    originalOverflow: '',
    originalPosition: '',
    originalTop: '',
    originalWidth: '',
    
    async init() {
      await waitForDependencies();
      this.createMobileDrawer();
      this.bindEvents();
      this.fixExistingIssues();
    },
    
    // 创建移动端抽屉
    createMobileDrawer() {
      // 检查是否已存在移动端抽屉
      if (document.querySelector('#mobile-filter-drawer')) return;
      
      const drawerHTML = `
        <div id="mobile-filter-drawer" class="mobile-filter-drawer">
          <div class="mobile-filter-backdrop"></div>
          <div class="mobile-filter-container">
            <div class="mobile-filter-header">
              <h2>Filter</h2>
              <button class="mobile-filter-close" aria-label="关闭">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>
            </div>
            <div class="mobile-filter-content">
              <div class="mobile-filter-loading" style="display: none;">
                <div class="loading-spinner"></div>
              </div>
              <div id="mobile-filter-content-inner"></div>
            </div>
            <div class="mobile-filter-footer">
              <button class="mobile-filter-clear">Clear all</button>
              <button class="mobile-filter-apply">Application filtering</button>
            </div>
          </div>
        </div>
      `;
      
      document.body.insertAdjacentHTML('beforeend', drawerHTML);
    },
    
    // 修复现有问题
    fixExistingIssues() {
      // 移除可能导致冲突的事件监听器
      this.removeConflictingListeners();
      
      // 修复z-index问题
      this.fixZIndexIssues();
      
      // 修复iOS滚动问题
      this.fixIOSScrollIssues();
    },
    
    removeConflictingListeners() {
      // 移除所有现有的facets__button监听器
      const buttons = document.querySelectorAll('.facets__button');
      buttons.forEach(button => {
        const newButton = button.cloneNode(true);
        button.parentNode.replaceChild(newButton, button);
      });
    },
    
    fixZIndexIssues() {
      // 确保移动端按钮在最上层
      const mobileButtons = document.querySelectorAll('.facets__button');
      mobileButtons.forEach(button => {
        button.style.zIndex = '1000';
        button.style.position = 'relative';
      });
    },
    
    fixIOSScrollIssues() {
      // 修复iOS Safari的100vh问题
      const fixViewport = () => {
        const vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
      };
      
      fixViewport();
      window.addEventListener('resize', fixViewport);
    },
    
    bindEvents() {
      // 绑定筛选按钮点击事件
      this.bindFilterButtons();
      
      // 绑定关闭按钮事件
      this.bindCloseEvents();
      
      // 绑定背景点击事件
      this.bindBackdropClick();
      
      // 绑定ESC键事件
      this.bindEscapeKey();
      
      // 绑定应用/清除按钮事件
      this.bindActionButtons();
    },
    
    bindFilterButtons() {
      document.addEventListener('click', (e) => {
        const button = e.target.closest('.facets__button');
        if (button && window.innerWidth <= 920) {
          e.preventDefault();
          e.stopPropagation();
          this.openFilter();
        }
      });
    },
    
    bindCloseEvents() {
      // 关闭按钮
      document.addEventListener('click', (e) => {
        const closeBtn = e.target.closest('.mobile-filter-close');
        if (closeBtn) {
          e.preventDefault();
          this.closeFilter();
        }
      });
    },
    
    bindBackdropClick() {
      document.addEventListener('click', (e) => {
        const backdrop = e.target.closest('.mobile-filter-backdrop');
        if (backdrop) {
          this.closeFilter();
        }
      });
    },
    
    bindEscapeKey() {
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen) {
          this.closeFilter();
        }
      });
    },
    
    bindActionButtons() {
      // 清除所有
      document.addEventListener('click', (e) => {
        const clearBtn = e.target.closest('.mobile-filter-clear');
        if (clearBtn) {
          e.preventDefault();
          this.clearAllFilters();
        }
      });
      
      // 应用筛选
      document.addEventListener('click', (e) => {
        const applyBtn = e.target.closest('.mobile-filter-apply');
        if (applyBtn) {
          e.preventDefault();
          this.applyFilters();
        }
      });
    },
    
    async openFilter() {
      if (this.isOpen) return;
      
      try {
        this.isOpen = true;
        this.scrollPosition = window.pageYOffset;
        
        // 获取筛选内容
        await this.loadFilterContent();
        
        // 显示抽屉
        this.showDrawer();
        
        // 防止背景滚动
        this.preventBodyScroll();
        
      } catch (error) {
        console.error('打开筛选失败:', error);
        this.isOpen = false;
      }
    },
    
    closeFilter() {
      if (!this.isOpen) return;
      
      this.isOpen = false;
      this.hideDrawer();
      this.restoreBodyScroll();
    },
    
    async loadFilterContent() {
      const container = document.querySelector('#mobile-filter-content-inner');
      if (!container) return;
      
      // 显示加载状态
      document.querySelector('.mobile-filter-loading').style.display = 'flex';
      
      try {
        // 获取当前页面的筛选内容
        const filterContent = document.querySelector('#FacetFiltersFormMobile') || 
                             document.querySelector('#FacetFiltersForm');
        
        if (filterContent) {
          // 克隆内容到移动端抽屉
          const clonedContent = filterContent.cloneNode(true);
          
          // 移除可能导致高度问题的样式
          const innerElements = clonedContent.querySelectorAll('.mobile-facets__inner, .mobile-facets__main');
          innerElements.forEach(el => {
            el.style.maxHeight = 'none';
            el.style.overflow = 'visible';
          });
          
          container.innerHTML = '';
          container.appendChild(clonedContent);
          
          // 确保所有内容可见
          setTimeout(() => {
            const scrollArea = document.querySelector('.mobile-filter-content');
            if (scrollArea) {
              scrollArea.scrollTop = 0;
            }
          }, 100);
          
          // 重新绑定事件
          this.rebindFilterEvents(container);
        }
        
      } catch (error) {
        console.error('加载筛选内容失败:', error);
        container.innerHTML = '<p>加载失败，请刷新页面重试</p>';
      } finally {
        document.querySelector('.mobile-filter-loading').style.display = 'none';
      }
    },
    
    rebindFilterEvents(container) {
      // 重新绑定复选框事件
      const checkboxes = container.querySelectorAll('input[type="checkbox"]');
      checkboxes.forEach(checkbox => {
        checkbox.addEventListener('change', (e) => {
          // 使用现有的FacetFiltersForm逻辑
          if (typeof FacetFiltersForm !== 'undefined') {
            const form = e.target.closest('form');
            if (form) {
              const formData = new FormData(form);
              const searchParams = new URLSearchParams(formData).toString();
              
              // 延迟应用，给用户视觉反馈
              clearTimeout(this.applyTimeout);
              this.applyTimeout = setTimeout(() => {
                FacetFiltersForm.renderPage(searchParams, e);
              }, 300);
            }
          }
        });
      });
    },
    
    showDrawer() {
      const drawer = document.querySelector('#mobile-filter-drawer');
      if (drawer) {
        drawer.classList.add('active');
      }
    },
    
    hideDrawer() {
      const drawer = document.querySelector('#mobile-filter-drawer');
      if (drawer) {
        drawer.classList.remove('active');
      }
    },
    
    preventBodyScroll() {
      this.originalOverflow = document.body.style.overflow;
      this.originalPosition = document.body.style.position;
      this.originalTop = document.body.style.top;
      this.originalWidth = document.body.style.width;
      
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.top = `-${this.scrollPosition}px`;
      document.body.style.width = '100%';
    },
    
    restoreBodyScroll() {
      document.body.style.overflow = this.originalOverflow;
      document.body.style.position = this.originalPosition;
      document.body.style.top = this.originalTop;
      document.body.style.width = this.originalWidth;
      
      window.scrollTo(0, this.scrollPosition);
    },
    
    clearAllFilters() {
      // 清除所有筛选条件
      const form = document.querySelector('#mobile-filter-content-inner form');
      if (form) {
        const checkboxes = form.querySelectorAll('input[type="checkbox"]');
        checkboxes.forEach(checkbox => {
          checkbox.checked = false;
        });
        
        // 应用清除
        if (typeof FacetFiltersForm !== 'undefined') {
          const searchParams = '';
          FacetFiltersForm.renderPage(searchParams);
          this.closeFilter();
        }
      }
    },
    
    applyFilters() {
      // 应用当前选择的筛选
      const form = document.querySelector('#mobile-filter-content-inner form');
      if (form && typeof FacetFiltersForm !== 'undefined') {
        const formData = new FormData(form);
        const searchParams = new URLSearchParams(formData).toString();
        FacetFiltersForm.renderPage(searchParams);
        this.closeFilter();
      }
    }
  };
  
  // 错误处理
  const ErrorHandler = {
    init() {
      window.addEventListener('error', (e) => {
        if (e.filename.includes('facets')) {
          console.error('筛选相关错误:', e.error);
        }
      });
    }
  };
  
  // 初始化
  function initialize() {
    try {
      ErrorHandler.init();
      MobileFilterManager.init();
      console.log('移动端筛选修复V3已初始化');
    } catch (error) {
      console.error('移动端筛选初始化失败:', error);
    }
  }
  
  // 等待DOM加载
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    setTimeout(initialize, 100);
  }
  
  // 处理页面导航
  document.addEventListener('shopify:section:load', () => {
    window.mobileFiltersV3Initialized = false;
    setTimeout(initialize, 100);
  });
  
})();
